import React, { useState, useRef, useEffect } from "react";
import ResourcesAndReusables from "./ResourcesAndReusables.jsx";
import ContentHeader from "../ContentHeader";
import List from "../List.jsx";
import Modal from "../Modal.jsx";
import DocPost from "../DocPost.jsx";
import NoContent from "../NoContent.jsx";

import data from "../../../../_data/resources-and-reusables.json";

export default function ReusableCatalog() {
  const [reusables, setReusables] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const selectedItem = useRef(null);

  useEffect(() => {
    let visibleReusables = [];

    if (data && data.reusables) {
      visibleReusables = data.reusables.filter((p) => p.isVisible);
    }

    setReusables(visibleReusables);
  }, []);

  if (!reusables) return <NoContent message={"No reuasbles found"} />;

  return (
    <>
      <ResourcesAndReusables />

      <ContentHeader
        title={"Reusable Catalog"}
        caption={
          "Browse through reusable components and know how they are implemented and their use cases."
        }
      />

      <List
        data={reusables}
        itemsPerPage={3}
        itemNameKey={"title"}
        itemExcerptKey={"description"}
        itemFields={[
          {
            key: "componentType",
            label: "Component Type",
            type: "chip",
          },
          {
            key: "implementations",
            label: "Implementations",
            type: "chip",
          },
        ]}
        listFilterKey={"componentType"}
        listFilterVals={["Authentication", "Integration", "Form"]}
        onItemClick={(item) => {
          selectedItem.current = item;
          setShowModal(true);
        }}
      />

      {showModal && (
        <Modal
          onClose={() => {
            selectedItem.current = null;
            setShowModal(false);
          }}
        >
          <ModalContent item={selectedItem.current} />
        </Modal>
      )}
    </>
  );
}

function ModalContent({ item }) {
  return (
    <div className="reusable-modal-content">
      <h1>{item.title}</h1>
      <hr />
      <DocPost path={item.href} />
    </div>
  );
}
